/* 
	
	---------  STICKY  --------- 

	scrollElement: 		Element, auf welchem der Scroll geschieht
	classElement:			Element, auf welches die CSS Klasse angewendet wird, wenn das markerElement das Ziel erreicht	
	markerElement:		Element, welches den Breakpoint erreichen muss
	breakpoint:				Abstand vom oberen Bildschirmrand, welches das MarkerElement erreichen muss, damit die CSS Klasse angewendet wird,
	cssClass:					CSS Klasse, die bei Erreichung des Breakpoints angewendet werden soll
	scrollDirection:	Richtung, in der der Scroll geschehen soll

*/

function etxScrollClass(scrollElement, classElement, markerElement, breakpoint, cssClass, scrollDirection) {
	
	let currentScrollElement		= scrollElement || window;
	let currentCssClass					= cssClass || 'sticky';
	let currentScrollDirection 	= scrollDirection || 'down'; 
	
	
	etxScrollClassCheck(currentScrollElement, classElement, markerElement, breakpoint, currentCssClass, currentScrollDirection);
	
	
	$(currentScrollElement).on("scroll", function() {
  	etxScrollClassCheck(scrollElement, classElement, markerElement, breakpoint, currentCssClass, currentScrollDirection);
	});			

}


function etxScrollClassCheck(scrollElement, classElement, markerElement, breakpoint, cssClass, scrollDirection) {
	
	let currentClassElement 		= $(classElement);
	let currentMarkerElement 	= $(markerElement);
	
	let scrollTop     	= $(scrollElement).scrollTop();			// window.pageYOffset / 
  let elementOffset	 	= currentMarkerElement.offset().top;
    
  
  // Edge Case: Wenn das Window bereits heruntergescrollt ist und dann noch ein Scroll Element geprüft werden soll, muss der Window Scroll kompensiert werden
  let distance      	= -(elementOffset - scrollTop);
  
  if (scrollElement != window) {
	  let distance      	= -(elementOffset - (scrollTop + $(window).scrollTop()));
  }	
	
	
	//console.log(elementOffset + ' / ' + scrollTop + ' = ' + distance  + ' / ' + breakpoint);
	
	
	if (distance >= breakpoint) {
  	
  	if (scrollDirection == 'down') {
	  	currentClassElement.addClass(cssClass);
  	}
  	else {
	  	currentClassElement.removeClass(cssClass);
  	}
  	
	}
	else {
		
		if (scrollDirection == 'down') {
	  	currentClassElement.removeClass(cssClass);
  	}
  	else {
	  	currentClassElement.addClass(cssClass);
  	}
  	
	}
}





/*

	etxScrollClass(window , '.PageActions__sticky', this, scrollTop, 'scolling', 'down');

	
	classElement 		= $('.PageActions__sticky');
	markerElement 	= $('.PageActions');
	
	scrollTop     	= $(window).scrollTop();
  elementOffset	 	= $(window).offset().top;
	

*/